import { render, staticRenderFns } from "./primerCupon.vue?vue&type=template&id=d2ea9a28&scoped=true"
import script from "./primerCupon.vue?vue&type=script&lang=js"
export * from "./primerCupon.vue?vue&type=script&lang=js"
import style0 from "./primerCupon.vue?vue&type=style&index=0&id=d2ea9a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ea9a28",
  null
  
)

export default component.exports